import { Interpolation, InterpolationFunction, StyledProps } from 'styled-components';

export type LifeThemeCornerStyle = 'cornerStyle1' | 'cornerStyle2' | 'cornerStyle3' | 'cornerStyle4';

type CornerStyleMap = {
  [cornerStyle in LifeThemeCornerStyle]?: Interpolation<StyledProps<unknown>>;
};

type InterpolationFactory = <P = unknown>(map: CornerStyleMap) => InterpolationFunction<StyledProps<P>>;

export const cornerStyleInterpolationFactory: InterpolationFactory = (map) => {
  return ({ theme }) => {
    return map[theme.Global?.cornerStyle ?? 'cornerStyle2'];
  };
};
